<template>
  <div class="sign_view">
    <template v-if="isShowData">
      <div class="query_wapper">
        <div class="query_item" v-if="details">
          <el-button-group>
            <el-button
              @click="selectType(1)"
              :class="switchType === 1?'select':'normal'"
              style="width:100px"
            >报名表</el-button>
            <el-button @click="selectType(2)" :class="switchType === 2?'select':'normal'">运动员照片</el-button>
          </el-button-group>
          <el-select
            style="margin:0 20px;"
            v-model="query.year"
            @change="getMatch"
            :popper-append-to-body="false"
          >
            <el-option
              v-for="(item,index) in yearLists"
              :value="item.value"
              :label="item.label"
              :key="index"
            ></el-option>
          </el-select>
          <el-select
            v-model="query.matchName"
            :popper-append-to-body="false"
            @change="$event=>getSignDetail($event)"
          >
            <el-option
              v-for="(item,index) in matchList"
              :key="index"
              :value="item.id"
              :label="item.matchName"
            ></el-option>
          </el-select>
        </div>
        <div class="query_item" v-if="true">
          <el-button type="warning" style="width:90px;margin-right:10px" @click="print">打印</el-button>
          <!-- <el-button type="primary" style="width:90px" @click="exportPdf">导出</el-button> -->
        </div>
      </div>
      <template v-if="details.matchName">
        <main v-if="switchType === 1">
          <h1>{{details.matchName}}报名表</h1>
          <div class="info">
            <div>
              <section>
                <p class="info_title first_title">
                  <span>校</span>
                  <span>名：</span>
                </p>
                <span class="info_text" style="width:585px;">{{schoolName}}</span>
              </section>
              <section style="margin-right:0;">
                <p class="info_title first_title">
                  <span>组</span>
                  <span>别：</span>
                </p>
                <span class="info_text">{{details.groupText}}</span>
              </section>
            </div>
            <div class="top_info">
              <section>
                <p class="info_title first_title">
                  <span>领</span>
                  <span>队：</span>
                </p>
                <span class="info_text" style>{{details.leaderName}}</span>
              </section>
              <section>
                <p class="info_title first_title" style="width:90px">
                  <span>手</span>
                  <span>机：</span>
                </p>
                <span class="info_text" style>{{details.leaderPhone}}</span>
              </section>
              <section style="margin-right:0">
                <p class="info_title first_title">
                  <span>邮</span>
                  <span>箱：</span>
                </p>
                <span class="info_text">{{details.leaderEmail}}</span>
              </section>
            </div>
            <div class="top_info">
              <section>
                <p class="info_title first_title">
                  <span>主</span>
                  <span>教</span>
                  <span>练：</span>
                </p>
                <span class="info_text" style>{{details.headCoachName}}</span>
              </section>
              <section>
                <p class="info_title first_title" style="width:90px">
                  <span>手</span>
                  <span>机：</span>
                </p>
                <span class="info_text" style>{{details.headCoachPhone}}</span>
              </section>
              <section style="margin-right:0">
                <p class="info_title first_title">
                  <span>邮</span>
                  <span>箱：</span>
                </p>
                <span class="info_text">{{details.headCoachEmail}}</span>
              </section>
            </div>
            <div>
              <section>
                <p class="info_title first_title">
                  <span>教</span>
                  <span>练：</span>
                </p>
                <span class="info_text" style="min-width:242px;">{{details.coachNames}}</span>
              </section>
              <section>
                <span class="info_title" style="width:90px">工作人员：</span>
                <span class="info_text" style="min-width:120px">{{details.workerNames}}</span>
              </section>
            </div>
          </div>
          <div class="table_list">
            <table style="margin-bottom:20px;" v-for="(item,index) in getTableList" :key="item">
              <tbody>
                <tr v-for="(temp,num) in columns" :key="index + '_' + num">
                  <td
                    style="border:1px solid #222;padding: 12px 0;
                min-width: 0;
                box-sizing: border-box;
                text-overflow: ellipsis;
                vertical-align: middle;
                position: relative;
                text-align: center;"
                  >
                    <div
                      style="box-sizing: border-box;
                    overflow: hidden;
                    width:100px;
                    text-overflow: ellipsis;
                    white-space: normal;
                    word-break: break-all;
                    line-height: 23px;
                    padding-left: 10px;
                    padding-right: 10px;"
                    >{{temp.name}}</div>
                  </td>
                  <template v-for="(i,n) in details.athleteList.slice(index * 5,(index + 1) * 5)">
                    <td
                      style="border:1px solid #222;padding: 12px 0;
                min-width: 0;
                width:200px;
                box-sizing: border-box;
                text-overflow: ellipsis;
                vertical-align: middle;
                position: relative;
                text-align: center;"
                      :key="index + '_' + num + n"
                    >
                      <div
                        style="box-sizing: border-box;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: normal;
                    word-break: break-all;
                    line-height: 23px;
                    padding-left: 10px;
                    padding-right: 10px;"
                      >{{temp.key === 'heightAndWeight'?(!i['height'] && !i['weight'])?'':(i['height'] + 'cm/' + i['weight'] + 'kg'):temp.key === 'startSchoolDate'?(!i[temp.key]?'':formatTime(i[temp.key])):i[temp.key]}}</div>
                    </td>
                  </template>
                </tr>
              </tbody>
            </table>
            <div
              v-if="details.state === 0"
              style="height:200px;color:#444;padding:20px;border:1px solid #222;margin-bottom:20px"
            >
              <section
                style="font-size:24px;display:flex;height:100%;
            flex-direction:column;align-items:center;justify-content:center"
              >
                <p>报名未提交</p>
                <el-button
                  v-if="userInfo.type === 4"
                  style="margin:20px 0 0 0"
                  type="primary"
                  @click="moveSubmit"
                >前往提交</el-button>
              </section>
            </div>
            <div
              v-else
              style="height:200px;color:#444;padding:20px;border:1px solid #222;margin-bottom:20px"
            >
              <p style="font-size:20px;">体育部意见：</p>
              <p
                style="font-size:24px;text-align:center;margin-top:50px;"
              >{{details.state === 1?'待审核':details.state === 2?'已驳回':'同意'}}</p>
            </div>
          </div>
        </main>
        <athletesPhoto v-else :details="tableData"></athletesPhoto>
        <div
          style="margin:20px 0;display:flex;justify-content:center;width:995px"
          v-if="switchType === 1 && details.state === 2 && userInfo.type === 4"
        >
          <el-button type="primary" @click="moveSubmit">前往修改</el-button>
        </div>
      </template>
      <template v-else>
        <main v-if="switchType === 1">
          <h1>{{matchName}}报名表</h1>
          <div class="info">
            <div>
              <section>
                <p class="info_title first_title">
                  <span>校</span>
                  <span>名：</span>
                </p>
                <span class="info_text" style="width:585px;"></span>
              </section>
              <section style="margin-right:0">
                <p class="info_title first_title">
                  <span>组</span>
                  <span>别：</span>
                </p>
                <span class="info_text"></span>
              </section>
            </div>
            <div class="top_info">
              <section>
                <p class="info_title first_title">
                  <span>领</span>
                  <span>队：</span>
                </p>
                <span class="info_text" style></span>
              </section>
              <section>
                <p class="info_title first_title" style="width:90px">
                  <span>手</span>
                  <span>机：</span>
                </p>
                <span class="info_text" style></span>
              </section>
              <section style="margin-right:0">
                <p class="info_title first_title">
                  <span>邮</span>
                  <span>箱：</span>
                </p>
                <span class="info_text"></span>
              </section>
            </div>
            <div class="top_info">
              <section>
                <p class="info_title first_title">
                  <span>主</span>
                  <span>教</span>
                  <span>练：</span>
                </p>
                <span class="info_text" style></span>
              </section>
              <section>
                <p class="info_title first_title" style="width:90px">
                  <span>手</span>
                  <span>机：</span>
                </p>
                <span class="info_text" style></span>
              </section>
              <section style="margin-right:0">
                <p class="info_title first_title">
                  <span>邮</span>
                  <span>箱：</span>
                </p>
                <span class="info_text"></span>
              </section>
            </div>
            <div>
              <section>
                <p class="info_title first_title">
                  <span>教</span>
                  <span>练：</span>
                </p>
                <span class="info_text" style="min-width:242px;"></span>
              </section>
              <section>
                <span class="info_title" style="width:90px">工作人员：</span>
                <span class="info_text" style="min-width:120px"></span>
              </section>
            </div>
          </div>
          <div class="table_list">
            <table style="margin-bottom:20px;">
              <tbody>
                <tr v-for="(temp,num) in columns" :key="num">
                  <td
                    style="border:1px solid #000;padding: 12px 0;
                min-width: 0;
                box-sizing: border-box;
                text-overflow: ellipsis;
                vertical-align: middle;
                position: relative;
                text-align: center;"
                  >
                    <div
                      style="box-sizing: border-box;
                    overflow: hidden;
                    width:100px;
                    text-overflow: ellipsis;
                    white-space: normal;
                    word-break: break-all;
                    line-height: 23px;
                    padding-left: 10px;
                    padding-right: 10px;"
                    >{{temp.name}}</div>
                  </td>
                  <template v-for="(i,n) in 5">
                    <td
                      style="border:1px solid #000;padding: 12px 0;
                min-width: 0;
                width:200px;
                box-sizing: border-box;
                text-overflow: ellipsis;
                vertical-align: middle;
                position: relative;
                text-align: center;"
                      :key="num + '_' + n"
                    >
                      <div
                        style="box-sizing: border-box;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: normal;
                    word-break: break-all;
                    line-height: 23px;
                    padding-left: 10px;
                    padding-right: 10px;"
                      ></div>
                    </td>
                  </template>
                </tr>
              </tbody>
            </table>
            <template>
              <div
                style="height:200px;color:#444;padding:20px;border:1px solid #000;margin-bottom:20px"
              >
                <section
                  style="font-size:24px;display:flex;height:100%;
            flex-direction:column;align-items:center;justify-content:center"
                >
                  <p>报名未填写</p>
                  <el-button
                    style="margin:20px 0 0 0"
                    type="primary"
                    @click="$router.push('/basketball/basketball-application-form')"
                  >前往填写</el-button>
                </section>
              </div>
            </template>
          </div>
        </main>
      </template>
      <div id="listPrint" style="position:absolute;left:-50000px;top:-10000px">
        <listPrint ref="listPrint" :info="printInfo" :matchList="matchList"></listPrint>
      </div>
    </template>
    <template v-else>
      <div class="query_wapper">
        <div class="query_item">
          <el-button-group>
            <el-button
              @click="selectType(1)"
              :class="switchType === 1?'select':'normal'"
              style="width:100px"
            >报名表</el-button>
            <el-button @click="selectType(2)" :class="switchType === 2?'select':'normal'">运动员照片</el-button>
          </el-button-group>
          <el-select
            :popper-append-to-body="false"
            style="margin:0 20px;"
            v-model="query.year"
            @change="getMatch"
          >
            <el-option
              v-for="(item,index) in yearLists"
              :value="item.value"
              :label="item.label"
              :key="index"
            ></el-option>
          </el-select>
          <el-select
            :popper-append-to-body="false"
            v-model="query.matchName"
            @change="$event=>getSignDetail($event)"
          >
            <el-option
              v-for="(item,index) in matchList"
              :key="index"
              :value="item.id"
              :label="item.matchName"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div style="padding:160px 0 0 250px">
        <img src="../../assets/img/signUp/no_data.png" alt />
      </div>
    </template>
    <div
      v-if="!hideMask"
      style="width:100%;height:100vh;position:fixed;background:#fff;top:106px;z-index:999999;left:290px;"
    ></div>
  </div>
</template>
<script>
import { getSignListBySchool, signDetail } from "@/api/sign-up-match";
import { method } from "@/utils/utils";
import listPrint from "@/components/list-print";
import athletesPhoto from "./components/athletes-photo";
import { getSession } from "@/utils/storage";
import { selectiveYear } from "@/common/js/mixins";
export default {
  mixins: [selectiveYear],
  // 报名表查看
  components: {
    athletesPhoto,
    listPrint
  },
  data() {
    return {
      hideMask: false,
      switchType: 1,
      query: {
        matchName: "",
        year: ""
      },
      printInfo: {
        id: "",
        year: "",
        project: ""
      },
      matchList: [],
      details: {},
      userInfo: JSON.parse(getSession("userInfo")),
      schoolName: JSON.parse(getSession("userInfo")).schoolName,
      isShowData: true,
      tableData: {},
      columns: [
        {
          key: "signNumber",
          name: "号码"
        },
        { key: "position", name: "位置" },
        { key: "athleteName", name: "姓名" },
        { key: "studentNumber", name: "学号" },
        { key: "startSchoolDate", name: "入学时间" },
        { key: "heightAndWeight", name: "身高、体重" },
        { key: "registerNumber", name: "队员注册号" }
      ]
    };
  },
  computed: {
    // 表格显示数量
    getTableList() {
      /**
       * 每个表格显示5项数据，如果数据小于5条，则使用空对象填充
       */
      let num = 0;

      if (this.details.athleteList && this.details.athleteList.length < 5) {
        let length = 5 - this.details.athleteList.length;
        for (let i = 0; i < length; i++) {
          this.details.athleteList.push({});
        }

        num = 1;
      } else if (
        /**
         * 数据大于5或等于5条时，则计算表格展示数量，并判断最后一个表格数据<5条时 使用空数据填充
         */
        this.details.athleteList &&
        this.details.athleteList.length >= 5
      ) {
        let length = this.details.athleteList.length;
        if (length / 5 > parseInt(length / 5)) {
          num = parseInt(length / 5) + 1;
        } else {
          num = length / 5;
        }
        if (this.details.athleteList.slice((num - 1) * 5, num * 5).length < 5) {
          let length =
            5 - this.details.athleteList.slice((num - 1) * 5, num * 5).length;
          for (let i = 0; i < length; i++) {
            this.details.athleteList.push({});
          }
        }
      }
      return num;
    },
    // 根据id查询赛事名称
    matchName() {
      let str = "";
      this.matchList.filter(item => {
        if (item.id === this.query.matchName) str = item.matchName;
      });
      return str;
    },
    formatTime() {
      return data => {
        return method.timeFormat(data);
      };
    }
  },
  methods: {
    // 调用打印功能
    print() {
      this.$nextTick(() => {
        Object.assign(this.printInfo, {
          id: this.query.matchName,
          year: this.query.year,
          project: 8
        });
      });
      let interval = setInterval(() => {
        if (this.$refs.listPrint.isRender) {
          clearInterval(interval);
          this.$refs.listPrint.print();
        }
      }, 300);
    },
    // 导出pdf
    exportPdf() {
      this.$nextTick(() => {
        Object.assign(this.printInfo, {
          id: this.query.matchName,
          year: this.query.year,
          project: 8
        });
      });
      let interval = setInterval(() => {
        if (this.$refs.listPrint.isRender) {
          clearInterval(interval);
          this.$refs.listPrint.exportPdf();
        }
      }, 300);
    },
    // 前往提交
    moveSubmit() {
      let id = null;
      this.matchList.filter(item => {
        if (item.id === this.query.matchName) id = item.matchId;
      });
      this.$router.push({
        path: "/basketball/basketball-application-form",
        query: {
          id,
          year: this.query.year
        }
      });
    },
    // 获取详情数据
    getSignDetail(id) {
      signDetail({ project: 8, id })
        .then(res => {
          if (!res) {
            res = { matchName: "" };
          }
          this.details = res;
          this.isShowData = true;
          this.hideMask = true;
          this.tableData = JSON.parse(JSON.stringify(res));
        })
        .catch(err => {
          if (err.data.msg === "当前没有赛事") {
            this.isShowData = false;
          }
          this.hideMask = true;
        });
    },
    // 获取赛事列表
    getMatch() {
      getSignListBySchool({
        project: 8,
        year: this.$route.query.year ? this.$route.query.year : this.query.year
      })
        .then(res => {
          if (res.length > 0) {
            this.matchList = res;
            let id = res[0].id;
            if (this.$route.query.id) {
              res.filter(item => {
                if (item.matchId === this.$route.query.id) id = item.id;
              });
            }
            this.query.matchName = id;
            this.isShowBtn = true;
            this.getSignDetail(id);
          } else {
            this.matchList = [];
            this.query.matchName = "";
            this.isShowData = false;
            this.details = {};
          }
          this.hideMask = true;
        })
        .catch(err => {
          if (err.data.msg === "当前没有赛事") {
            this.isShowBtn = false;
          }
          this.hideMask = true;
        });
    },
    // 切换按钮组
    selectType(type) {
      this.switchType = type;
    }
  },
  mounted() {
    this.getYearLists(this.query, this.getMatch);
  }
};
</script>
<style lang="less" scoped>
.sign_view {
  .select {
    background: #1e63b0;
    color: #fff;
  }
  .normal {
    background: transparent;
    color: #999;
  }
  > main {
    width: 1050px;
    border: 1px solid #ddd;
    padding: 30px 0 0 0;
    > h1 {
      font-size: 24px;
      color: #444;
      text-align: center;
    }
    .info {
      margin: 40px 0;
      padding: 0 20px;
      > .top_info {
        > section {
          width: 33%;
        }
      }
      > div {
        display: flex;
        align-items: center;
        font-size: 18px;
        color: #444;
        margin-bottom: 20px;
        > section {
          margin-right: 20px;
          display: flex;
          align-items: center;
          > .first_title {
            width: 80px;
            display: flex;
            justify-content: space-between;
          }
          > .info_text {
            // font-size: 14px;
          }
        }
      }
    }
    .table_list {
      padding: 0 20px;
    }
  }
}
</style>